import { render, staticRenderFns } from "./PortalEdituser.vue?vue&type=template&id=eb96b28c&scoped=true&"
import script from "./PortalEdituser.vue?vue&type=script&lang=js&"
export * from "./PortalEdituser.vue?vue&type=script&lang=js&"
import style0 from "./PortalEdituser.vue?vue&type=style&index=0&id=eb96b28c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb96b28c",
  null
  
)

export default component.exports